import React from 'react';
import { useTranslation } from 'react-i18next';

import { Alert } from '../../../shared/components/alert/Alert';

interface ProfileNameFieldProps {
  label: string;
  name: string;
  // eslint-disable-next-line no-unused-vars
  handleNameChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  errorMessage: string;
  hasError?: boolean;
  errorText?: string;
  isAfterSubmit?: boolean;
}

function ProfileNameField({
  label,
  name,
  handleNameChange,
  errorMessage,
  hasError,
  errorText,
  isAfterSubmit,
}: ProfileNameFieldProps) {
  const { t } = useTranslation();

  return (
    <fieldset className={`account_details_container${hasError ? ' error' : ''}`}>
      <legend className="not_logged_label" id="name-legend">
        {hasError && isAfterSubmit && <span className="error-indicator">{t('error')}</span>}
        {label}
        {t('input.label.required')}
      </legend>
      <input
        id="name"
        className="value_input"
        type="text"
        value={name}
        onChange={handleNameChange}
        autoComplete="off"
        aria-labelledby="name-legend"
      />
      <Alert
        id="name-error-alert"
        isVisible={hasError}
        message={errorText || errorMessage}
        type="error"
        variant="outline"
        size="md"
      />
    </fieldset>
  );
}

export default ProfileNameField;
